import {
  AddIcon,
  Button,
  Flex,
  Hide,
  SubtractIcon,
  Typography,
} from '@iheartjane/reefer';

interface QuantitySelectorProps {
  decrementQuantity: () => void;
  incrementQuantity: () => void;
  inventoryCount?: number;
  maxQuantity?: number;
  minQuantity?: number;
  onPdp?: boolean;
  value: number;
}

export const QuantitySelector = ({
  value,
  decrementQuantity,
  incrementQuantity,
  inventoryCount,
  maxQuantity = 5,
  minQuantity = 1,
  onPdp = false,
}: QuantitySelectorProps) => {
  const isMinimumVal = value <= minQuantity;
  const isMaximumVal = value >= maxQuantity;
  const hasLowInventory = onPdp && inventoryCount && inventoryCount < 4;

  return (
    <Flex
      justifyContent="center"
      alignSelf="center"
      alignItems="center"
      data-testid="quantity-selector"
    >
      <Button.Icon
        ariaLabel={
          !isMinimumVal
            ? `Decrease quantity to ${value - 1}`
            : 'Cannot decrease quantity further'
        }
        data-testid="decrement-quantity"
        disabled={isMinimumVal}
        icon={<SubtractIcon color="text-main" />}
        onClick={decrementQuantity}
        variant="tertiary"
      />
      <Flex flexDirection="column" width={64} mx={hasLowInventory ? 16 : 0}>
        <Hide aria-live="polite" isHidden>
          {`Quantity: ${value}`}
        </Hide>
        <Typography
          textAlign="center"
          variant="body-bold"
          data-testid="product-quantity"
        >
          {onPdp && 'Qty: '}
          {value}
        </Typography>
        {hasLowInventory && (
          <Typography textAlign="center" variant="mini">
            Only {inventoryCount} left
          </Typography>
        )}
      </Flex>
      <Button.Icon
        ariaLabel={
          !isMaximumVal
            ? `Increase quantity to ${value + 1}`
            : 'Cannot increase quantity further'
        }
        data-testid="increment-quantity"
        disabled={isMaximumVal}
        icon={<AddIcon color="text-main" />}
        onClick={incrementQuantity}
        variant={onPdp ? 'tertiary' : undefined}
      />
    </Flex>
  );
};
